/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/blog-chef/:id(\d+)'>.
 * Regex-параметр :id(\d+) эмулируется numericIdShell: не-число → 404.
 */
import { createFileRoute } from '@tanstack/react-router';
import { numericIdShell } from '../compat/shells';
import Article from '@routes/Article';

export const Route = createFileRoute('/blog-chef/$id')({
  component: numericIdShell(Article, '/blog-chef/:id(\\d+)')
});
